"use client";

import { Header, Footer } from "@/pages/landing/components";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

function TermsOfServicePage() {
  const { t } = useTranslation();

  return (
    <div className="bg-lavender-light w-full">
      <div
        className={cn(
          "flex flex-col min-h-screen max-w-7xl mx-auto",
          "2k:max-w-[80%]",
          "4k:max-w-[80%]"
        )}
      >
        <Header />
        <main className="px-6 md:px-14 py-12 md:py-20 grow">
          <h1 className="font-h1 mb-8">{t("legal.tos.title")}</h1>
          <p className="text-sm text-muted-foreground mb-12">
            {t("legal.tos.lastUpdated", { date: "2026-03-19" })}
          </p>

          <div className="prose prose-neutral max-w-3xl space-y-8">
            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.acceptance.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.acceptance.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.description.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.description.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.accounts.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.accounts.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.content.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.content.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.usage.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.usage.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.thirdParty.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.thirdParty.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.payment.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.payment.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.termination.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.termination.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.liability.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.liability.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.changes.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.changes.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.tos.sections.contact.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.tos.sections.contact.content")}
              </p>
            </section>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default TermsOfServicePage;
